import { StateContext } from '@ngxs/store';
import { ExhibitionStateModel } from '../exhibition.state';
import { ChangeSubtitle } from '../exhibition.state.actions';

export const changeSubtitle = (ctx: StateContext<ExhibitionStateModel>, action: ChangeSubtitle) => {
    ctx.patchState({
        subtitle: action.payload.subtitle
    });
};
